import { SupplierGetResponseType } from "@sellar-io/api-v2/types";

type PriceTierDiscountsType =
  SupplierGetResponseType["CustomerZones"][number]["PriceTier"]["PriceTierDiscounts"];

export const getItemTypeTitle = (discount: PriceTierDiscountsType[number]) => {
  switch (true) {
    case discount.itemType === "can":
      return "Cases of cans";
    case discount.itemType === "draught":
      return "Draught items";
    case discount.itemType === "bottle":
      return "Cases of bottles";
    case discount.itemType === "cask":
      return "Casks";
    case discount.itemType === "keg":
      return "Kegs";
    default:
      return "Any items";
  }
};
